import { baseQuery } from "@/queries"

import { KirbyPageData } from "."
import { KirbyQuerySchema } from "./kql"
import { KirbyImageData } from "./image"

// ALL PROJECTS
export const projectPreviewSelect: KirbyQuerySchema["select"] = {
  id: "page.id",
  uri: "page.uri",
  title: "page.projectitle",
  name: "page.name",
  year: "page.year",
  hasThumbnail: "page.thumbnail.toFile",
  hasVideo: "page.thecontent.toBlocks.filterBy('type', 'video').isNotEmpty",
  hasSketchfab:
    "page.thecontent.toBlocks.filterBy('type', 'sketchfab').isNotEmpty",
  programme: {
    query: "page.programme.toPage",
    select: baseQuery,
  },
}

export interface ProjectPreviewData {
  id: string
  uri: string
  title: string
  name: string
  year: string
  hasThumbnail: null | Record<string, unknown> // This is now fetched dynamically and added to the project.
  hasVideo: boolean
  hasSketchfab: boolean
  programme: KirbyPageData
  thumb: string
  isPartOfGroup?: boolean
}

export interface GroupProjectPreviewData extends ProjectPreviewData {
  students: (KirbyPageData & { name: string })[]
  customNames: string
}

export interface KirbyAllProjectsData {
  projects: ProjectPreviewData[]
  groupProjects: GroupProjectPreviewData[]
}

export const allProjectsQuerySelect: KirbyQuerySchema["select"] = {
  groupProjects: {
    query:
      'site.find("programmes").children.children.filterBy("thumbnail", "!=", null).shuffle',
    select: {
      ...projectPreviewSelect,
      students: {
        query: "page.students.toPages",
        select: { ...baseQuery, name: "page.name" },
      },
      customNames: "page.studentsCustomNames",
      programme: { query: "page.parent", select: baseQuery },
    },
  },
  // projects: {
  //   query:
  //     'site.find("students").children.filterBy("thumbnail", "!=", null).shuffle',
  //   select: projectPreviewSelect,
  // },
  projects: {
    query: "site.find('students').children",
    select: projectPreviewSelect,
  },
}

export const allProjectsQuery: KirbyQuerySchema = {
  query: "site",
  select: allProjectsQuerySelect,
}
